<template>
  <TopGradientBlockLayout>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <div v-if="!openForm" class="flex items-center justify-between">
        <BaseButton @click="openForm=true"
                    theme="red"
                    class="w-91">
          {{ $t('createSource') }}
        </BaseButton>
        <IncomeSpaceSettings/>
      </div>
      <IncomeSettingsForm v-else/>
    </template>
    <IncomeList :list="incomes"
                @editIncome="setEditIncome"/>
    <transition name="modal">
      <IncomeSettingsEditModal v-if="!!edit_income"
                               :edit_income="edit_income"
                               @close="edit_income=null"/>
    </transition>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import IncomeSettingsForm from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsForm";
import IncomeList from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeList";
import CustomModal from "@/components/UI/modals/CustomModal";
import IncomeSettingsEditModal from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSettingsEditModal";
import IncomeSpaceSettings from "@/components/cabinet/SpaceSettings/IncomeSettings/IncomeSpaceSettings";

export default {
  name: "IncomeSettings",
  components: {
    IncomeSpaceSettings,
    IncomeSettingsEditModal,
    CustomModal,
    TopGradientBlockLayout,
    BaseButton,
    IncomeSettingsForm,
    IncomeList,
  },
  data() {
    return {
      edit_income: null,
      openForm: false,
      dataFetched: true
    }
  },
  computed: {
    ...mapState('space/incomes', ['incomes']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  methods: {
    ...mapActions('space/incomes', ['getIncomes']),
    setEditIncome(val) {
      this.edit_income = val;
    },
    async fetchMainData() {
      try {
        await this.$store.dispatch('space/incomes/getIncomes');
      } catch (e) {
        throw e;
      }
    },
  },
  async created() {
    await this.fetchMainData();
    this.dataFetched = true;
  },
  i18n: {
    messages: {
      en: {
        createSource: 'Create income source'
      },
      ru: {
        createSource: 'Создать источник дохода'
      }
    }
  }
}
</script>
